const gocityBranding = require("./gocity.json");
const loopBranding = require("./loop.json");
const miamiMocaadBranding = require("./miamimocaad.json");
const mudBranding = require("./mud.json");
const nextRealityBranding = require("./nextreality.json");
const ocinemaBranding = require("./ocinema.json");
const onlandBranding = require("./onland.json");

const BRANDING_CONFIGS = {
  gocity: gocityBranding,
  loop: loopBranding,
  miamimocaad: miamiMocaadBranding,
  mud: mudBranding,
  nextreality: nextRealityBranding,
  ocinema: ocinemaBranding,
  onland: onlandBranding
};

const getBrandingConfigName = appName => {
  const normalizedAppName = String(appName || "")
    .trim()
    .toLowerCase();

  return normalizedAppName || "onland";
};

const loadBrandingConfig = appName => {
  const configName = getBrandingConfigName(appName);

  return BRANDING_CONFIGS[configName] || onlandBranding;
};

exports.getBrandingConfigName = getBrandingConfigName;
exports.loadBrandingConfig = loadBrandingConfig;
